/* eslint-disable import/no-anonymous-default-export */
import * as actionType from "./constants";

const initialState = {
    getNormalRecomDownloadResponse: { isLoading: false },
    getMobileRecommendationsResponse: { isLoading: false },
    mobileRecommendationEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            image_or_not: null,
            me: null,
            recommendation_ids: []
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        scrollPosition: 0,
        selectedPreviewId: null
    },
    convertedMobileRecommendationEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            image_or_not: null,
            me: null,
            recommendation_ids: []
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        selectedPreviewId: null
    },
    mobileRecommendationVideoEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        incompletedRecoms: 0,
        selectedRecomIds: []
    },
    getMobileRecommendationByIdResponse: { isLoading: false },
    getMobileRecommendationVideosResponse: { isLoading: false },
    getMobileRecommendationTemplateResponse: { isLoading: false },
    getMobileRecommendationDropdownResponseLoading: {},
    getMobileRecommendationDropdownResponse: {},
    getMobileRecommendationDropdownCount: {},
    getMobileRecommendationCommonData: null,
    getMobileRecommendationCommonDataLoading: false,
    updateMultiMobileRecommendation: null,
    updateMultiMobileRecommendationLoading: false,
    getAllMobileRecommendationIdsResponse: null,
    getAllMobileRecommendationIdsResponseLoading: false,
    masterFilterList: {},
    appliedFilterNames: {},
    restoreMobileRecomDataLogsResponse: { loading: false },
    getListForMobileRecommendationCommonFilterResponse: null,
    getMobileRecommendationsExcelLoading: { isLoading: false },
    getTableSummaryDataResponse: {},
    getTableSummaryDataLoading: false,
    getAiAnalyseKeys: { loading: false },
    getExcelLoading: false,
    getGroupEditProgressResponse: { loading: false },
    revertMobileRecomResponse: null,
    revertMobileRecomResponseLoading: false,
    revertMobileRecomByIdResponse: null,
    searchAndReplaceMobileRecomResponse: null,
    searchAndReplaceMobileRecomLoading: false,
    findMobileRecomBeforeReplacingResponse: null,
    findMobileRecomBeforeReplacingLoading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_MOBILE_RECOMMENDATIONS_REQUEST:
            return {
                ...state,
                getMobileRecommendationsResponse: { isLoading: true }
            };
        case actionType.GET_ALL_MOBILE_RECOMMENDATIONS_SUCCESS:
            return {
                ...state,
                getMobileRecommendationsResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_ALL_MOBILE_RECOMMENDATIONS_FAILURE:
            return {
                ...state,
                getMobileRecommendationsResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_MOBILE_RECOMMENDATION_BY_ID_REQUEST:
            return {
                ...state,
                getMobileRecommendationByIdResponse: { isLoading: true }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_BY_ID_SUCCESS:
            return {
                ...state,
                getMobileRecommendationByIdResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_BY_ID_FAILURE:
            return {
                ...state,
                getMobileRecommendationByIdResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_MOBILE_RECOMMENDATION_TEMPLATE_REQUEST:
            return {
                ...state,
                getMobileRecommendationTemplateResponse: { isLoading: true }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                getMobileRecommendationTemplateResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_TEMPLATE_FAILURE:
            return {
                ...state,
                getMobileRecommendationTemplateResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_RECOMMENDATIONS_VOICE_NOTES_REQUEST:
            return {
                ...state,
                getMobileRecommendationVideosResponse: { isLoading: true }
            };
        case actionType.GET_RECOMMENDATIONS_VOICE_NOTES_SUCCESS:
            return {
                ...state,
                getMobileRecommendationVideosResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATIONS_VOICE_NOTES_FAILURE:
            return {
                ...state,
                getMobileRecommendationVideosResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_MOBILE_RECOMMENDATION_DROPDOWNS_REQUEST:
            return {
                ...state,
                getMobileRecommendationDropdownResponseLoading: { ...state.getMobileRecommendationDropdownResponseLoading, [action.entity]: true },
                getMobileRecommendationDropdownCount: {
                    ...state.getMobileRecommendationDropdownCount,
                    [action.entity]: 0
                }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_DROPDOWNS_SUCCESS:
            return {
                ...state,
                getMobileRecommendationDropdownResponse: { ...state.getMobileRecommendationDropdownResponse, [action.entity]: action.response },
                getMobileRecommendationDropdownResponseLoading: { ...state.getMobileRecommendationDropdownResponseLoading, [action.entity]: false },
                getMobileRecommendationDropdownCount: {
                    ...state.getMobileRecommendationDropdownCount,
                    [action.entity]: action.count
                }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_DROPDOWNS_FAILURE:
            return {
                ...state,
                getMobileRecommendationDropdownResponseLoading: { ...state.getMobileRecommendationDropdownResponseLoading, [action.entity]: false },
                getMobileRecommendationDropdownCount: {
                    ...state.getMobileRecommendationDropdownCount
                }
            };

        case actionType.UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_SUCCESS:
            const key = action.entity === "convertedMobileRec" ? "convertedMobileRecommendationEntityParams" : "mobileRecommendationEntityParams";
            return {
                ...state,
                [key]: {
                    ...action.response
                }
            };
        case actionType.UPDATE_SURVEY_RECOMMENDATION_ENTITY_PARAMS_FAILURE:
            const keys = action.entity === "convertedMobileRec" ? "convertedMobileRecommendationEntityParams" : "mobileRecommendationEntityParams";
            return {
                ...state,
                [keys]: {
                    entity: null,
                    selectedEntity: null,
                    selectedRowId: null,
                    paginationParams: {
                        totalPages: 0,
                        perPage: 100,
                        currentPage: 0,
                        totalCount: 0
                    },
                    params: {
                        limit: 100,
                        offset: 0,
                        search: "",
                        filters: null,
                        filterKeys: null,
                        list: null,
                        order: null
                    },
                    wildCardFilterParams: {},
                    filterParams: {},
                    tableConfig: null
                }
            };

        case actionType.RESET_REDUCER_SUCCESS:
            return {
                ...state,
                getMobileRecommendationTemplateResponse: { isLoading: false },
                getMobileRecommendationsResponse: { isLoading: false },
                getAllMobileRecommendationIdsResponse: null,
                getGroupEditProgressResponse: { loading: false },
                updateMultiMobileRecommendation: null,
                searchAndReplaceMobileRecomResponse: null,
                findMobileRecomBeforeReplacingResponse: null
            };

        case actionType.RESET_FORM:
            return {
                ...state,
                getMobileRecommendationByIdResponse: null
            };

        case actionType.UPDATE_MOBILE_RECOMMENDATION_FIELDS_REQUEST:
            return {
                ...state,
                updateMobileRecommendationFieldsResponse: null,
                updateMobileRecommendationFieldsResponseLoading: action.response
            };
        case actionType.UPDATE_MOBILE_RECOMMENDATION_FIELDS_SUCCESS:
            return {
                ...state,
                updateMobileRecommendationFieldsResponse: { success: true, data: { ...action.response } },
                updateMobileRecommendationFieldsResponseLoading: false
            };
        case actionType.UPDATE_MOBILE_RECOMMENDATION_FIELDS_FAILURE:
            return {
                ...state,
                updateMobileRecommendationFieldsResponse: { success: false, ...action.error },
                updateMobileRecommendationFieldsResponseLoading: false
            };

        case actionType.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_REQUEST:
            return {
                ...state,
                getMobileRecommendationCommonDataLoading: true
            };
        case actionType.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_SUCCESS:
            return {
                ...state,
                getMobileRecommendationCommonData: { success: true, data: { ...action.response } },
                getMobileRecommendationCommonDataLoading: false
            };
        case actionType.GET_MOBILE_RECOMMENDATION_COMMON_DATA_BY_IDS_FAILURE:
            return {
                ...state,
                getMobileRecommendationCommonData: { success: false, ...action.error },
                getMobileRecommendationCommonDataLoading: false
            };

        case actionType.UPDATE_MULTI_MOBILE_RECOMMENDATION_REQUEST:
            return {
                ...state,
                updateMultiMobileRecommendationLoading: true
            };
        case actionType.UPDATE_MULTI_MOBILE_RECOMMENDATION_SUCCESS:
            return {
                ...state,
                updateMultiMobileRecommendation: { success: true, data: { ...action.response } },
                updateMultiMobileRecommendationLoading: false
            };
        case actionType.UPDATE_MULTI_MOBILE_RECOMMENDATION_FAILURE:
            return {
                ...state,
                updateMultiMobileRecommendation: { success: false, ...action.error },
                updateMultiMobileRecommendationLoading: false
            };

        case actionType.RESET_MULTI_MR_COMMON_DATA_SUCCESS:
            return {
                ...state,
                getMobileRecommendationCommonData: null
            };

        case actionType.RESET_MULTI_MR_COMMON_DATA_FAILURE:
            return {
                ...state,
                getMobileRecommendationCommonData: null
            };

        case actionType.GET_ALL_MOBILE_RECOMMENDATION_IDS_REQUEST:
            return {
                ...state,
                getAllMobileRecommendationIdsResponseLoading: true
            };
        case actionType.GET_ALL_MOBILE_RECOMMENDATION_IDS_SUCCESS:
            return {
                ...state,
                getAllMobileRecommendationIdsResponse: { success: true, data: { ...action.response } },
                getAllMobileRecommendationIdsResponseLoading: false
            };
        case actionType.GET_ALL_MOBILE_RECOMMENDATION_IDS_FAILURE:
            return {
                ...state,
                getAllMobileRecommendationIdsResponse: { success: false, ...action.error },
                getAllMobileRecommendationIdsResponseLoading: false
            };

        case actionType.GET_MOBILE_RECOMMENDATION_FILTER_REQUEST:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: true }
                }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_FILTER_SUCCESS:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { list: [...action.response?.list], count: action.response?.count, loading: false }
                }
            };
        case actionType.GET_MOBILE_RECOMMENDATION_FILTER_FAILURE:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: false }
                }
            };
        case actionType.SET_MOBILE_RECOMMENDATION_APPLIED_FILTER_NAMES:
            return {
                ...state,
                appliedFilterNames: {
                    ...state.appliedFilterNames,
                    [action.paramKey]: { ...(state.appliedFilterNames?.[action.paramKey] ?? {}), ...(action.names ?? {}) }
                }
            };

        case actionType.CLEAR_ENTITY_PARAMS:
            return {
                ...state,
                mobileRecommendationEntityParams: {
                    entity: null,
                    selectedEntity: null,
                    selectedRowId: null,
                    paginationParams: {
                        totalPages: 0,
                        perPage: 100,
                        currentPage: 0,
                        totalCount: 0
                    },
                    params: {
                        limit: 100,
                        offset: 0,
                        search: "",
                        filters: null,
                        filterKeys: null,
                        list: null,
                        order: null
                    },
                    wildCardFilterParams: {},
                    filterParams: {},
                    tableConfig: null
                }
            };
        case actionType.RESTORE_DATA_LOG_REQUEST:
            return {
                ...state,
                restoreMobileRecomDataLogsResponse: { loading: true }
            };
        case actionType.RESTORE_DATA_LOG_SUCCESS:
            return {
                ...state,
                restoreMobileRecomDataLogsResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.RESTORE_DATA_LOG_FAILURE:
            return {
                ...state,
                restoreMobileRecomDataLogsResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_SUCCESS:
            return {
                ...state,
                getListForMobileRecommendationCommonFilterResponse: {
                    success: true,
                    list: action.response?.list || [],
                    count: action.response?.count
                }
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_MOB_RECOMMENDATIONS_FAILURE:
            return {
                ...state,
                getListForMobileRecommendationCommonFilterResponse: { success: false, ...action.error }
            };

        case actionType.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_REQUEST:
            return {
                ...state,
                getMobileRecommendationsExcelLoading: { isLoading: true }
            };
        case actionType.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_SUCCESS:
            return {
                ...state,
                getMobileRecommendationsExcelLoading: { isLoading: false }
            };
        case actionType.GET_MOBILE_RECOMMENDATIONS_EXCEL_EXPORT_FAILURE:
            return {
                ...state,
                getMobileRecommendationsExcelLoading: { isLoading: false }
            };

        case actionType.GET_TABLE_SUMMARY_DATA_REQUEST:
            return {
                ...state,
                getTableSummaryDataLoading: true
            };
        case actionType.GET_TABLE_SUMMARY_DATA_SUCCESS:
            return {
                ...state,
                getTableSummaryDataResponse: action.response,
                getTableSummaryDataLoading: false
            };
        case actionType.GET_TABLE_SUMMARY_DATA_FAILURE:
            return {
                ...state,
                getTableSummaryDataResponse: action.error,
                getTableSummaryDataLoading: false
            };
        case actionType.GET_AI_ANALYSE_KEY_REQUEST:
            return {
                ...state,
                getAiAnalyseKeys: { loading: true }
            };
        case actionType.GET_AI_ANALYSE_KEY_SUCCESS:
            return {
                ...state,
                getAiAnalyseKeys: {
                    loading: false,
                    ...action.response
                }
            };
        case actionType.GET_AI_ANALYSE_KEY_FAILURE:
            return {
                ...state,
                getAiAnalyseKeys: {
                    loading: false,
                    ...action.error
                }
            };
        case actionType.GET_MOBILE_RECOMMENDATIONS_EXPORT_REQUEST:
            return {
                ...state,
                getExcelLoading: true
            };
        case actionType.GET_MOBILE_RECOMMENDATIONS_EXPORT_SUCCESS:
            return {
                ...state,
                getExcelLoading: false
            };
        case actionType.GET_MOBILE_RECOMMENDATIONS_EXPORT_FAILURE:
            return {
                ...state,
                getExcelLoading: { isLoading: false }
            };
        case actionType.GET_GROUP_EDIT_PROGRESS_REQUEST:
            return {
                ...state,
                getGroupEditProgressResponse: { ...state.getGroupEditProgressResponse, loading: true }
            };
        case actionType.GET_GROUP_EDIT_PROGRESS_SUCCESS:
            return {
                ...state,
                getGroupEditProgressResponse: {
                    loading: false,
                    ...action.response
                }
            };
        case actionType.GET_GROUP_EDIT_PROGRESS_FAILURE:
            return {
                ...state,
                getGroupEditProgressResponse: {
                    loading: false,
                    ...action.error
                }
            };
        case actionType.RESET_GROUP_EDIT_PROGRESS_REDUCER_SUCCESS:
            return {
                ...state,
                getGroupEditProgressResponse: { loading: false }
            };
        case actionType.UPDATE_SCROLL_SUCCESS:
            const type = action?.entity === "convertedMobileRec" ? "convertedMobileRecommendationEntityParams" : "mobileRecommendationEntityParams";
            return {
                ...state,
                [type]: {
                    ...state?.[type],
                    scrollPosition: action.response
                }
            };
        case actionType.UPDATE_SCROLL_FAILURE:
            const types = action?.entity === "convertedMobileRec" ? "convertedMobileRecommendationEntityParams" : "mobileRecommendationEntityParams";
            return {
                ...state,
                [types]: {
                    ...state?.[types],
                    scrollPosition: 0
                }
            };
        case actionType.REVERT_MOBILE_RECOM_REQUEST:
            return {
                ...state,
                revertMobileRecomResponse: null,
                revertMobileRecomResponseLoading: true
            };
        case actionType.REVERT_MOBILE_RECOM_SUCCESS:
            return {
                ...state,
                revertMobileRecomResponse: { success: true, ...action.response },
                revertMobileRecomResponseLoading: false
            };
        case actionType.REVERT_MOBILE_RECOM_FAILURE:
            return {
                ...state,
                revertMobileRecomResponse: { success: false, ...action.error },
                revertMobileRecomResponseLoading: false
            };
        case actionType.REVERT_MOBILE_RECOM_BY_ID_REQUEST:
            return {
                ...state,
                revertMobileRecomByIdResponse: { loading: true }
            };
        case actionType.REVERT_MOBILE_RECOM_BY_ID_SUCCESS:
            return {
                ...state,
                revertMobileRecomByIdResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.REVERT_MOBILE_RECOM_BY_ID_FAILURE:
            return {
                ...state,
                revertMobileRecomByIdResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.SEARCH_AND_REPLACE_MOBILE_RECOM_REQUEST:
            return {
                ...state,
                searchAndReplaceMobileRecomLoading: true
            };
        case actionType.SEARCH_AND_REPLACE_MOBILE_RECOM_SUCCESS:
            return {
                ...state,
                searchAndReplaceMobileRecomResponse: action.response,
                searchAndReplaceMobileRecomLoading: false
            };
        case actionType.SEARCH_AND_REPLACE_MOBILE_RECOM_FAILURE:
            return {
                ...state,
                searchAndReplaceMobileRecomResponse: { error: true, ...action.error },
                searchAndReplaceMobileRecomLoading: false
            };

        case actionType.FIND_MOBILE_RECOM_BEFORE_REPLACE_REQUEST:
            return {
                ...state,
                findMobileRecomBeforeReplacingLoading: true
            };
        case actionType.FIND_MOBILE_RECOM_BEFORE_REPLACE_SUCCESS:
            return {
                ...state,
                findMobileRecomBeforeReplacingResponse: action.response,
                findMobileRecomBeforeReplacingLoading: false
            };
        case actionType.FIND_MOBILE_RECOM_BEFORE_REPLACE_FAILURE:
            return {
                ...state,
                findMobileRecomBeforeReplacingLoading: false
            };
        default:
            return state;
    }
};
